import React, { useState, useEffect } from 'react';
import { Building2 } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BrandSelector = ({ selectedBrand, onBrandChange }) => {
  const [brands, setBrands] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    loadBrands();
  }, []);

  const loadBrands = async () => {
    try {
      const response = await axios.get(`${API}/brands`);
      setBrands(response.data);
      
      // Set first brand as default if none selected
      if (!selectedBrand && response.data.length > 0) {
        onBrandChange(response.data[0].id);
      }
    } catch (error) {
      console.error('Failed to load brands:', error);
    }
  };

  const getSelectedBrandName = () => {
    const brand = brands.find(b => b.id === selectedBrand);
    return brand ? brand.name : 'Select Brand';
  };

  const getSelectedBrandColor = () => {
    const brand = brands.find(b => b.id === selectedBrand);
    return brand?.color || '#2EB4AC';
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-4 py-2 bg-slate-800 dark:bg-slate-800 light:bg-white rounded-lg border border-slate-700 dark:border-slate-700 light:border-slate-300 hover:bg-slate-700 transition-colors"
      >
        <Building2 size={18} className="text-slate-400" />
        <div className="flex items-center gap-2">
          <span className="text-sm text-slate-400 dark:text-slate-400 light:text-slate-600">
            Viewing:
          </span>
          <span
            className="text-sm font-semibold px-2 py-0.5 rounded"
            style={{ 
              backgroundColor: `${getSelectedBrandColor()}20`,
              color: getSelectedBrandColor()
            }}
          >
            {getSelectedBrandName()}
          </span>
        </div>
        <svg
          className={`w-4 h-4 text-slate-400 transition-transform ${isOpen ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute top-full mt-2 w-64 bg-slate-800 dark:bg-slate-800 light:bg-white rounded-lg border border-slate-700 dark:border-slate-700 light:border-slate-300 shadow-xl z-20 max-h-80 overflow-y-auto">
            <div className="p-2">
              <div className="text-xs font-semibold text-slate-400 px-3 py-2">
                SELECT BRAND
              </div>
              {brands.map(brand => (
                <button
                  key={brand.id}
                  onClick={() => {
                    onBrandChange(brand.id);
                    setIsOpen(false);
                  }}
                  className={`w-full text-left px-3 py-2 rounded-lg hover:bg-slate-700 dark:hover:bg-slate-700 light:hover:bg-slate-100 transition-colors flex items-center gap-2 ${
                    selectedBrand === brand.id ? 'bg-slate-700 dark:bg-slate-700 light:bg-slate-100' : ''
                  }`}
                >
                  <div
                    className="w-3 h-3 rounded-full"
                    style={{ backgroundColor: brand.color }}
                  />
                  <span className="text-white dark:text-white light:text-slate-900">
                    {brand.name}
                  </span>
                  {selectedBrand === brand.id && (
                    <svg className="w-4 h-4 ml-auto text-teal-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  )}
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default BrandSelector;
